import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes
} from "react";
import { FaStarOfLife } from "react-icons/fa";
import { Cancel } from "../../assets";
interface Props extends HTMLAttributes<HTMLElement> {
    value: string | number;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: boolean;
    isRequired?: boolean;
    items?: any;
    error?: any;
    disabled?:boolean;
    emptyState?:any;
    objectList?:any;
    children?:any;
    selectStyle?:string;
}
 export function Dropdown({ value,emptyState, selectStyle, onChange, title, myStyle, lable, displayEmpty, placeholder, icon, iconBorder, hasNotice, isRequired, items, error , disabled , objectList , children }: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle} custom-dropdown`} >
            {lable &&
                <label className="custom-dropdown-lable">
                    {isRequired && <FaStarOfLife />}  {lable}

                </label>
            }
            <FormControl className="dropdown" >
                {title && <InputLabel className="dropdown-title">{title}</InputLabel>}
                <Select
                    value={value}
                    disabled={disabled}

                    label={title ? title : ""}
                    displayEmpty={displayEmpty}
                    placeholder={placeholder ? placeholder : ""}
                    onChange={onChange}
                    className={`${selectStyle} dropdown-select`}
                    IconComponent={() => (
                        value ? <Cancel width="10px" color="#0074BA" myStyle="cursor-pointer" onClick={()=>emptyState()}/> : null
                      )}

                    startAdornment={
                        icon &&
                        <InputAdornment position="end" >
                            {icon}
                            {iconBorder &&
                                <div className="dropdown-select-icon-border">
                                </div>
                            }
                        </InputAdornment>
                    }
                >
                    <MenuItem disabled value="">
                        {placeholder ? placeholder : "انتخاب کنید"}
                    </MenuItem>
                    {children}
                </Select>
                {error &&
                    <label className="dropdown-select-error">
                        {error}
                    </label>
                }
            </FormControl>
        </div>

    );
}

export default Dropdown;